import React from 'react';
import Linkify from 'react-linkify';
import styled from 'styled-components';

import { StyledInline } from 'modules/log/LogItem/styled';

const linkifyProps = { target: '_blank' };

const StyledLinkify = styled(Linkify)`
  white-space: pre-line;
`;

const Comment = ({ comment, ...props }) => {
  if (!comment) {
    return null;
  }

  return (
    <StyledInline {...props}>
      "<StyledLinkify properties={linkifyProps}>{comment}</StyledLinkify>"
    </StyledInline>
  );
};

export default Comment;
